import api from "./api";
const svc = {
  resumo: (idCondominio) => api("GET",`/dashboard/resumo?idCondominio=${idCondominio}`),
};
export default svc;
